import backend, {CLIENT_SUPPORT_API} from 'utils/backend/server/api_library';

const getEventFeedback = (eventFeedbackRn) => {
  const url = `${CLIENT_SUPPORT_API}/public/feedback/event/${eventFeedbackRn}`;
  return backend.get(url);
};

const sendEventFeedback = (eventFeedbackRn, body) => {
  const url = `${CLIENT_SUPPORT_API}/public/feedback/event/${eventFeedbackRn}`;
  return backend.put(url, body);
};

const createCaregiverFeedback = (clientRn, caregiverRn, body) => {
  const url = `${CLIENT_SUPPORT_API}/feedback/caregiver_feedback/client/${clientRn}/caregiver/${caregiverRn}`;
  return backend.post(url, body);
};

const getCaregiverFeedback = (clientRn, caregiverRn) => {
  const url = `${CLIENT_SUPPORT_API}/feedback/caregiver_feedback/client/${clientRn}/caregiver/${caregiverRn}`;
  return backend.get(url);
};

const createArticleFeedback = (clientRn, articleRn, body) => {
  const url = `${CLIENT_SUPPORT_API}/feedback/article_feedback/client/${clientRn}/article/${articleRn}`;
  return backend.post(url, body);
};

const getArticleFeedback = (clientRn, articleRn) => {
  const url = `${CLIENT_SUPPORT_API}/feedback/article_feedback/client/${clientRn}/article/${articleRn}`;
  return backend.get(url);
};

export default {
  getEventFeedback,
  sendEventFeedback,
  createCaregiverFeedback,
  getCaregiverFeedback,
  createArticleFeedback,
  getArticleFeedback,
};
